<svg
  [attr.width]="width || size"
  [attr.height]="height || size"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2.5"
  stroke-linecap="round"
  stroke-linejoin="round"
  class="animate-spin"
>
  <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
</svg>
